export const ListAndDetailSamplesGroupingsPageInfo = () => {
    return (
      <>
          You can group list items together.<br />
          This example groups cities by their countries.<br />
          You can set properties to start with groupings collapsed, change background colours (per group item if need be),
          or make it so that the groups can't be collapsed at all.<br />
          You can also change the indent spacing, and you can add multiple groups as well.
      </>
    )
  }
  